import React, { useMemo } from 'react';
import keyBy from 'lodash/keyBy';
import noop from 'lodash/noop';

import { TFunction, useTranslation } from '@lyearn/i18n';
import { BannerOutline } from '@lyearn/icons';
import { Box } from '@lyearn/ui';
import Form, { Field, FieldType, PicklistValue } from '@/components/Form';
import { FORM_PICKLIST_PROPS } from '@/modules/corporate/components/picklist';

const getPicklistOptions = (t: TFunction) => [
  { Icon: BannerOutline, label: t('SurveyEditor:WelcomeBlock'), value: 'WELCOME_BLOCK' },
];

const getFields = (t: TFunction, picklistValues: PicklistValue[]): Field[] => [
  {
    name: 'type',
    label: t('SurveyEditor:Block'),
    type: FieldType.Picklist,
    disabled: true,
    picklistValues,
    props: FORM_PICKLIST_PROPS,
  },
];

function WelcomeBlockSettings() {
  const { t } = useTranslation();
  const { fields, initialValues } = useMemo(() => {
    const picklistValues = getPicklistOptions(t);

    return {
      initialValues: { type: picklistValues[0].value },
      fields: keyBy(getFields(t, picklistValues), 'name'),
    };
  }, [t]);

  return (
    <Box className="p-16">
      <Form
        fields={fields}
        formName="welcome-block-settings-form"
        initialValues={initialValues}
        onSubmit={noop}
      />
    </Box>
  );
}

export default WelcomeBlockSettings;
